export enum LegalDocCode {
  TERMS_OF_SERVICE = 'TermsOfService',
  PRIVACY_NOTICE = 'PrivacyNotice',
  DATA_PROCESSING_SCHEDULE = 'DataProcessingSchedule',
}
